const SiteTypes = {
	LOADED: "LOADED",
	TOGGLE_MENU: "TOGGLE_MENU",
	CHANGE_ACTIVE_LINK: "CHANGE_ACTIVE_LINK",
	TOGGLE_MODAL_IOS: "TOGGLE_MODAL_IOS",
	TOGGLE_SIGN_FORM: "TOGGLE_SIGN_FORM",
	CHANGE_PROVINCE: "CHANGE_PROVINCE",
	SET_CITIES: "SET_CITIES",
	SET_LATLNG: "SET_LATLNG",
	TOGGLE_MARKER_LAYER: "TOGGLE_MARKER_LAYER",
	CLEAR_MARKERS: "CLEAR_MARKERS",
	// SET_ACCESSORY: "SET_ACCESSORY",
	SET_ACCESSORIES: "SET_ACCESSORIES",
	SET_PRODUCT: "SET_PRODUCT",
	SET_PRODUCTS: "SET_PRODUCTS",
	TOGGLE_TEC_ATTR: "TOGGLE_TEC_ATTR",
	SET_INFO: "SET_INFO",
	SET_ABOUT_US: "SET_ABOUT_US",
	SET_BASE_INFO: "SET_BASE_INFO",
	SET_EDUCATION: "SET_EDUCATION",
	SET_COUNT_UP: "SET_COUNT_UP",
	SET_NEAREST: "SET_NEAREST",
	SET_CITY: "SET_CITY",
	SET_LIST_PROVINCE: "SET_LIST_PROVINCE",
	SET_APPLICATION: "SET_APPLICATION",
	SET_NEWS: "SET_NEWS",
	SET_SLIDER: "SET_SLIDER",
	SET_TRACK_SYS: "SET_TRACK_SYS",
};

export default SiteTypes;
